export type SegmentErrorCode =
  | 'INVALID_REQUEST'
  | 'FILTER_NOT_ACCESSIBLE'
  | 'SEGMENT_CATEGORY_NOT_ACCESSIBLE'
  | 'SEGMENT_NOT_FOUND'
  | 'SEGMENT_CATEGORY_NOT_FOUND'
  | 'SEGMENT_CATEGORY_DUPLICATE_LABEL'
  | 'FILTER_NOT_FOUND'
  | 'FILTER_NOT_APPLICABLE'
  | 'INVALID_RANGE'
  | 'SELECTION_LIMIT_EXCEEDED'
  | 'SEGMENT_CAP_EXCEEDED'
  | 'SEGMENT_IMMUTABLE'
  | 'SEGMENT_CATEGORY_IMMUTABLE'
  | 'UNKNOWN';

export interface SegmentError {
  code: SegmentErrorCode;
  message: string;
}

/**
 * Best-effort error normaliser. `ky` (our HTTP client) throws `HTTPError`s
 * whose `.response` is a Fetch `Response` — the server-supplied
 * `{ code, message }` body must be read asynchronously via `.json()`, there
 * is no axios-style `.response.data` shortcut. Every non-abort error still
 * safely falls back to `UNKNOWN` with a derived message.
 */
export async function normaliseSegmentError(e: unknown): Promise<SegmentError> {
  const anyE = e as { response?: Response; message?: string };
  if (anyE?.response && typeof anyE.response.json === 'function') {
    try {
      const body = (await anyE.response.json()) as { code?: string; message?: string };
      if (body?.code && body?.message) {
        return { code: body.code as SegmentErrorCode, message: body.message };
      }
    } catch {
      // fall through to fallback
    }
  }
  return { code: 'UNKNOWN', message: anyE?.message ?? 'Unexpected error updating segment' };
}
